import { render, staticRenderFns } from "./ProductBundles.vue?vue&type=template&id=59a7148e"
import script from "./ProductBundles.vue?vue&type=script&lang=js"
export * from "./ProductBundles.vue?vue&type=script&lang=js"
import style0 from "./ProductBundles.vue?vue&type=style&index=0&id=59a7148e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports